<template>
  <b-modal
    id="saques-historico"
    no-enforce-focus
    title="Histórico de Saques"
    header-bg-variant="dark"
    header-close-variant="light"
    title-class="text-light font-18"
    hide-footer
    size="xl"
    @shown="openModal"
  >
    <div v-if="!loading" class="grid-web">
      <div class="row">
        <div class="col-12">
          <!-- Total Withdrawals -->
          <p class="contador text-primary">
            {{ withdrawals.length }} saques solicitados por esse produtor
          </p>
          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              :items="withdrawals"
              :fields="fieldsWithdrawals"
              responsive="sm"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              sort-icon-left
            >
              <!-- Creation Date -->
              <template v-slot:cell(created_at)="data">
                {{ data.value | datetime }}
              </template>
              <!-- Status -->
              <template v-slot:cell(status)="data">
                <div v-if="data.value === 'REQUESTED'"> Solicitado </div>
                <div v-if="data.value === 'ACCEPTED'"> Aceito </div>
              </template>
              <!-- Account Details -->
              <template v-slot:cell(_account)="data">
                <!-- Account National -->
                <div v-if="data.item.account && data.item.account.account && data.item.account.account_dv" class="d-flex">
                  <div>
                    <b class="mr-1">Conta:</b>
                    <span>
                      <img src="../../../assets/flags-country/brazil.png" height="19"> {{ `${data.item.account.account}-${data.item.account.account_dv}` }}
                    </span>
                  </div>
                  <div class="ml-1">
                    <b class="mr-1">Agência:</b>
                    <span>{{ data.item.account ? data.item.account.agency : '' }}</span>
                  </div>
                </div>
                <!-- Account International -->
                <div v-else-if="data.item.account && data.item.account.account">
                  <div>
                    <b class="mr-1">Conta/IBAN:</b>
                    <span>🌎 {{ data.item.account.account }}</span>
                  </div>
                </div>
                <!-- Type -->
                <div v-if="data.item.account" class="d-flex">
                  <div>
                    <!-- National -->
                    <b class="mr-1">Tipo de Conta:</b>
                    <span v-if="data.item.account ? data.item.account.type === 'CURRENT' : false">
                      Conta Corrente
                    </span>
                    <span v-if="data.item.account ? data.item.account.type === 'SAVINGS' : false">
                      Conta Poupança
                    </span>
                    <!-- International -->
                    <span v-if="data.item.account ? data.item.account.international_account_type === 'BANK_ACCOUNT' : false">
                      Conta Bancária
                    </span>
                    <span v-if="data.item.account ? data.item.account.international_account_type === 'IBAN' : false">
                      IBAN
                    </span>
                  </div>
                  <!-- Bank Number - Bank Name - National -->
                  <div v-if="data.item.account && data.item.account.bank_number && data.item.account.bank_name" class="ml-1">
                    <b class="mr-1">Banco:</b>
                    <span>
                      {{ `${data.item.account.bank_number} - ${data.item.account.bank_name}` }}
                    </span>
                  </div>
                  <!-- BIC_SWIFT -->
                  <div v-else-if="data.item.account && data.item.account.bic_swift" class="ml-1">
                    <b class="mr-1">BIC/SWIFT:</b>
                    <span>{{ data.item.account.bic_swift }}</span>
                  </div>
                </div>
                <!-- Client -->
                <div v-if="data.item.account">
                  <b class="mr-1">Cliente:</b>
                  <span>
                    {{ data.item.account ? data.item.account.cpf_cnpj : '' }} -
                    {{ data.item.account ? data.item.account.name : '' }}
                  </span>
                </div>
              </template>
              <!-- Amount -->
              <template v-slot:cell(amount)="data">
                <template v-if="data.item.base_currency">
                  {{ data.item.base_currency.currency_symbol }}
                </template>
                {{ formatMoney(data.value) }}
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <!-- Loading -->
    <div v-if="loading" class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Money from '@src/mixins/money'
import WithdrawService from '@services/resources/WithdrawService'
var service = WithdrawService.build()

export default {
  name: "ModalHistoric",
  mixins: [Money],
  props: {
    dados: {
      required: true,
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      fieldsWithdrawals: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'created_at', label: 'Data de Criação', sortable: false },
        { key: '_account', label: 'Dados da Conta', sortable: false },
        { key: 'amount', label: 'Valor', sortable: true },
      ],
      filter: '',
      filterOn: [],
      loading: false,
      sortBy: 'name',
      sortDesc: false,
      withdrawals: [],
    }
  },
  methods: {
    /**
     * Fires when the modal is opened. Makes a request to fetch the historical data, by the selected withdrawal id
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    openModal() {
      this.loading = true
      let data = {
        id: `/history/${this.dados.user_id}`,
      }
      service
        .read(data)
        .then(response => { this.withdrawals = response })
        .catch(err => console.error(err))
        .finally(() => { this.loading = false })
    },
  },
}
</script>

<style lang="scss">
.grid-web {
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
}

.grid-webhook {
  display: grid;
  grid-template-columns: 1fr 3fr 3fr 3fr;
  gap: 10px;
}

.grid-mb {
  display: grid;
  grid-template-columns: 1fr 3fr 3fr;
  gap: 10px;
}

.carousel-inner {
  border-radius: 3px !important;
}

.grid-tab {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}
.item-grid {
  max-height: 550px;
  overflow: auto;
}
.item-grid::-webkit-scrollbar {
  width: 12px;
}

.item-grid::-webkit-scrollbar-track {
  background: #f7f7f7;
}

.item-grid::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 20px;
  border: 3px solid #f7f7f7;
}

.carousel-control-prev,
.carousel-control-next {
  filter: invert(1);
}

textarea {
  resize: none;
}

.btnDownload {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(210, 210, 210);
  border-radius: 3px;
  cursor: pointer;
}

.actions-modal {
  margin-top: -17px;
  margin-bottom: -12px;
  gap: 10px;
  display: flex;
  justify-content: flex-end;
}

.image-size {
  img {
    height: 25vh;
    object-fit: contain;
  }
}

.to-label {
  font-weight: 600;
}

.grid-archive {
  display: grid;
  grid-template-columns: 5fr 1fr;
  gap: 10px;
  button {
    border: none;
  }
}
.contador {
  font-weight: 600;
  font-size: 18px;
  text-align: right;
}
</style>
